// Wit kruisje (16x16) voor de ronde sluitknoppen (CaseDetailDrawer, ManagePortals).
import React from "react";

export default function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-label="Close"
      style={{ userSelect: "none", display: "block" }}
    >
      <path
        d="M7.99984 7.05767L11.2997 3.75781L12.2425 4.70062L8.94264 8.00047L12.2425 11.3003L11.2997 12.2431L7.99984 8.94327L4.70002 12.2431L3.7572 11.3003L7.05704 8.00047L3.7572 4.70062L4.70002 3.75781L7.99984 7.05767Z"
        fill="white"
      />
    </svg>
  );
}
